import { render } from "./GridAtribute.vue?vue&type=template&id=9fae2cf0&scoped=true&ts=true"
import script from "./GridAtribute.vue?vue&type=script&lang=ts"
export * from "./GridAtribute.vue?vue&type=script&lang=ts"

import "./GridAtribute.vue?vue&type=style&index=0&id=9fae2cf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fae2cf0"]])

export default __exports__